"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var compLayoutUtils_1 = require("./compLayoutUtils");
var rowsAPIFactory_1 = require("./rowsAPIFactory");
var getPushMargins = function (compBottom, pushBottom, pushMargin) {
    var pushedTop = pushBottom + pushMargin;
    return pushedTop - compBottom > 70 ? _.max([10 - pushMargin, 0]) : pushBottom - compBottom;
};
var startNewRowIfNeeded = function (rowsAPI, possibleNewRowTop, isBottomParent) {
    if (!isBottomParent) {
        rowsAPI.closeRow(possibleNewRowTop);
    }
};
var setPushingCompGridData = function (compsGridData, rowsAPI, component, pushBottom, pushMargin, bottomParent) {
    var marginBottom = getPushMargins(compLayoutUtils_1.bottom(component), pushBottom, pushMargin);
    _.assign(compsGridData[component.id], { rowEnd: rowsAPI.count() + 1, bottomParent: bottomParent, marginBottom: marginBottom });
};
var splitSameRowAndSpanningComps = function (pushingComps, compsGridData, rowsAPI) {
    var currRow = rowsAPI.count();
    return _(pushingComps)
        .orderBy([compLayoutUtils_1.top], ['desc'])
        .partition(function (_a) {
        var id = _a.id;
        return compsGridData[id].rowStart === currRow;
    })
        .value();
};
var setSpanningCompsGridData = function (spanningComps, compsGridData, rowsAPI, pushBottom, pushMargin, isBottomParent) {
    if (_.isEmpty(spanningComps)) {
        return;
    }
    _.forEach(spanningComps, function (component) {
        rowsAPI.createExtraRows(compsGridData[component.id].rowStart, pushBottom);
        setPushingCompGridData(compsGridData, rowsAPI, component, pushBottom, pushMargin, isBottomParent);
    });
};
var setPushingCompsGridData = function (_a, pushingComps, pushBottom, pushMargin, isBottomParent) {
    var compsGridData = _a.compsGridData, rowsAPI = _a.rowsAPI;
    var _b = splitSameRowAndSpanningComps(pushingComps, compsGridData, rowsAPI), sameRowComps = _b[0], spanningComps = _b[1];
    if (!_.isEmpty(sameRowComps)) {
        _.forEach(sameRowComps, function (comp) { return setPushingCompGridData(compsGridData, rowsAPI, comp, pushBottom, pushMargin, isBottomParent); });
        rowsAPI.markRowWithContent();
    }
    setSpanningCompsGridData(spanningComps, compsGridData, rowsAPI, pushBottom, pushMargin, isBottomParent);
    startNewRowIfNeeded(rowsAPI, pushBottom, isBottomParent);
};
var setZeroHeightCompsGridData = function (_a, zeroHeightComps, isBottomParent) {
    var compsGridData = _a.compsGridData, rowsAPI = _a.rowsAPI;
    var currentRow = rowsAPI.count();
    var currentRowTop = rowsAPI.last();
    var marginTop = compLayoutUtils_1.top(_.first(zeroHeightComps)) - currentRowTop;
    _.forEach(zeroHeightComps, function (zeroHeightComp) {
        compsGridData[zeroHeightComp.id] = {
            id: zeroHeightComp.id,
            rowStart: currentRow,
            rowEnd: currentRow + 1,
            marginTop: marginTop,
            bottomParent: isBottomParent
        };
    });
    startNewRowIfNeeded(rowsAPI, currentRowTop + marginTop, isBottomParent);
};
var getWedgeStartRow = function (compsGridData, nearestTopTopPusher) { return nearestTopTopPusher ? compsGridData[nearestTopTopPusher].rowStart : 1; };
var addWedge = function (compsGridData, rowsAPI, compTop, nearestTopTopPusher, _a) {
    var softMargin = _a.softMargin;
    var startRow = getWedgeStartRow(compsGridData, nearestTopTopPusher);
    var rowIndex = startRow - 1;
    var wedgeTop = rowsAPI.get(rowIndex);
    var wedgeBottom = compTop - softMargin;
    var wedgeId = "wedge-" + (rowsAPI.count() + 1);
    rowsAPI.createExtraRows(startRow, wedgeBottom);
    compsGridData[wedgeId] = {
        id: wedgeId,
        isWedge: true,
        height: wedgeBottom - wedgeTop,
        rowStart: startRow,
        rowEnd: rowsAPI.count() + 1
    };
    rowsAPI.closeRow(wedgeBottom);
};
var shouldCreateWedge = function (rowsAPI, compTop, _a) {
    var minLockMargin = _a.minLockMargin;
    var isInFirstRow = rowsAPI.count() === 1;
    var currRowTop = rowsAPI.last();
    var distanceFromRowTop = compTop - currRowTop;
    return rowsAPI.isWedgePossible() && !isInFirstRow && distanceFromRowTop > minLockMargin;
};
var addWedgeIfNeeded = function (_a, y, startingCompsInY, zeroHeightCompsInY, nearestTopTopPusher, marginsOptions) {
    var compsGridData = _a.compsGridData, rowsAPI = _a.rowsAPI;
    if (shouldCreateWedge(rowsAPI, y, marginsOptions)) {
        var topTopPusher = getTopTopPusher(nearestTopTopPusher, startingCompsInY) || getTopTopPusher(nearestTopTopPusher, zeroHeightCompsInY);
        addWedge(compsGridData, rowsAPI, y, topTopPusher, marginsOptions);
        rowsAPI.setNoWedge();
    }
};
var getTopTopPusher = function (nearestTopTopPusher, components) {
    return _.find(nearestTopTopPusher, function (topTop, pushedCompId) { return _.some(components, function (comp) { return comp.id === pushedCompId; }); });
};
var setStartingCompGridData = function (compsGridData, startingCompId, marginTop, rowStart) {
    compsGridData[startingCompId] = {
        id: startingCompId,
        marginTop: marginTop,
        rowStart: rowStart,
        rowEnd: null
    };
};
var setStartingCompsGridData = function (_a, startingComps) {
    var compsGridData = _a.compsGridData, rowsAPI = _a.rowsAPI;
    var pointTop = compLayoutUtils_1.top(_.first(startingComps));
    var marginTop = pointTop - rowsAPI.last();
    var rowStart = rowsAPI.count();
    _.forEach(startingComps, function (_a) {
        var id = _a.id;
        return setStartingCompGridData(compsGridData, id, marginTop, rowStart);
    });
};
var calculateMeshCompsRows = function (sortedGridPointsData, gridVerticalArea, nearestTopTopPusher, marginsOptions) {
    var rowsAPI = rowsAPIFactory_1.create(gridVerticalArea.top);
    var compsGridData = _.reduce(sortedGridPointsData, function (compsGridDataWithRowsAPI, _a, pointIndex) {
        var y = _a.y, pushingComps = _a.pushingComps, pushMargin = _a.pushMargin, zeroHeightComps = _a.zeroHeightComps, startingComps = _a.startingComps;
        var isLastPoint = pointIndex === sortedGridPointsData.length - 1;
        if (pushingComps) {
            var isLastRow = isLastPoint && !zeroHeightComps;
            setPushingCompsGridData(compsGridDataWithRowsAPI, pushingComps, y, pushMargin, isLastRow);
        }
        if (zeroHeightComps || startingComps) {
            // todo - check what about zeroHeightComps -> nearestTopTopPusher
            addWedgeIfNeeded(compsGridDataWithRowsAPI, y, startingComps, zeroHeightComps, nearestTopTopPusher, marginsOptions);
        }
        if (zeroHeightComps) {
            setZeroHeightCompsGridData(compsGridDataWithRowsAPI, zeroHeightComps, isLastPoint);
        }
        if (startingComps) {
            setStartingCompsGridData(compsGridDataWithRowsAPI, startingComps);
            rowsAPI.setNoWedge();
        }
        return compsGridDataWithRowsAPI;
    }, { compsGridData: {}, rowsAPI: rowsAPI }).compsGridData;
    return compsGridData;
};
exports.default = calculateMeshCompsRows;
//# sourceMappingURL=calculateCompsGridData.js.map